import { productMap } from '@/constants/seeded/products';

/**
 * Use to get feature name for any product ID
 * @param id ID of product in `productMap` that should always match a seeded product ID in DB
 * @returns Product's feature name
 */
export const getProductFeatureNameById = (id?: number) => {
  const fallback = '';
  if (id) {
    const product = productMap.find((product) => product.id === id);
    if (product?.id) {
      return product.featureName;
    }
    return fallback;
  }
  return fallback;
};
